<template>
  <div class="clear_stroke">
    <IconButton
      class="clear_stroke__clear_button"
      :label="clearButtonLabel"
      @click.native="clearValue"
    >
      <font-awesome-icon :icon="['fal', 'undo']" />
    </IconButton>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUndo } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BaseComponent from "../BaseComponent";
import IconButton from "./IconButton.vue";

library.add(faUndo);

export default {
  name: "ClearButton",
  mixins: [BaseComponent],
  props: {
    clearButtonLabel: {
      type: String,
      default: "clear",
    },
  },
  components: {
    FontAwesomeIcon,
    IconButton,
  },
  methods: {
    clearValue() {
      this.$emit("clear");
    },
  },
};
</script>

<style scoped lang="scss">
.clear_stroke {
  width: 100%;
  max-width: 650px;
  display: block;
  text-align: right;
}
.clear_stroke__clear_button {
  display: inline-block;
  margin-top: 8px;
  height: 32px;
}
</style>
